import React from 'react'
import AboutHead from './AboutHead'
import DynamicBreadcrumb from '../../components/DynamicBreadcrumb'
import AboutTrust from './AboutTrust'
import AboutTeamSlide from './AboutTeamSlide'
import AboutCounter from './AboutCounter'
import AboutGoals from './AboutGoals'
import AboutDocs from './AboutDocs'
import AboutOffice from './AboutOffice'

const breadcrumbData = [
  {
    page:"Home",
    slug:"/"
  },
  {
    page:"About Us",
    slug:""
  },
]

export default function About() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <AboutHead breadcrumbData={breadcrumbData}/>
      <AboutTrust/>
      <AboutTeamSlide/>
      <AboutCounter/>
      <AboutGoals/>
      <AboutDocs/>
      <AboutOffice/>
    </>
  )
}
